import { Event } from '@/application/interfaces/event-tracker.interface';

export class PageViewEvent extends Event {
  eventName = 'Page View';

  constructor() {
    super();

    const { host, pathname } = window.location;
    const pageLocation = `${host}${pathname}`;

    this.properties = {
      gt_Location: pageLocation,
    };
  }
}
